import axios from 'axios';
import './bootstrap';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { createApp } from 'vue';
import UserBrandedAssets from './components/Pages/Users/UserBrandedAssets.vue';
import AppNotification from './components/Shared/AppNotification.vue';

window.axios = axios;
if (axios) {
    console.log('axios is loaded');
}

const userBrandedAssetsEl = document.getElementById('user-branded-assets-app');
if (userBrandedAssetsEl) {
    // Create and mount the notification component separately
    const notifEl = document.createElement('div');
    document.body.appendChild(notifEl);
    const notifApp = createApp(AppNotification);
    const notifInstance = notifApp.mount(notifEl);

    // Mount the main app with provide referencing the notification instance
    const app = createApp({
        components: {
            UserBrandedAssets,
        },
        provide() {
            return {
                showNotification: (type, message, detail = null) => {
                    notifInstance.showNotification(type, message, detail);
                },
            };
        },
    });
    app.mount('#user-branded-assets-app');
}
